import { styled } from '@clickcease/cc-client-components-lib'

export const CountriesBreakdownWrapper = styled('div', {
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  marginTop: '20px',
  flex: 1,
})

export const CountriesBreakdownTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '600',
  padding: '16px 20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const StyledTable = styled('table', {
  width: '100%',
  borderCollapse: 'collapse',
  padding: '0 20px 20px',
})

export const StyledTh = styled('th', {
  padding: '12px 20px',
  borderBottom: '1px solid #eaeaea',
  fontWeight: '600',
  fontSize: '14px',
  textAlign: 'left',
  color: '$textColor',
})

export const StyledTd = styled('td', {
  padding: '12px 20px',
  borderBottom: '1px solid #f5f5f5',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const NumberCell = styled('td', {
  padding: '12px 20px',
  borderBottom: '1px solid #f5f5f5',
  fontSize: '14px',
})

export const FlagStyles = {
  width: '20px',
  height: '15px',
  boxShadow: '0 0 1px rgba(0, 0, 0, 0.2)',
}

export const TooltipStyle = {
  width: '16px',
  height: '16px',
}
